import { useAuth0 } from "@auth0/auth0-react";
import { useForm } from "@subly/s1/features/form/fabric";
import { zod } from "@subly/s1/features/form/models";


export const useAuth = () => {
	const auth0 = useAuth0();

	const form = useForm({
		defaultValues: {
			email: ""
		},
		validators: {
			onSubmit: zod.object({
				email: zod.email()
			})
		},
		onSubmit: ({ value }) => {
			auth0.loginWithRedirect({ authorizationParams: { login_hint: value.email, prompt: "login" } });
		}
	});
	return { ...auth0, form };
};